import React from 'react';
import { useCommandPaletteRegistryCurrentAttribution } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';

export const JiraCommandPaletteErrorBoundary = ({
	id,
	children,
}: {
	id: string;
	children: React.ReactNode | React.ReactNode[];
}): React.JSX.Element => {
	const [data] = useCommandPaletteRegistryCurrentAttribution();
	return (
		<JSErrorBoundary
			id={id}
			packageName="jiraCommandPaletteIntegration"
			fallback="unmount"
			teamName={data?.registryData?.teamName || 'deliveroo'}
			attributes={data?.analyticsAttributes}
		>
			{children}
		</JSErrorBoundary>
	);
};
